import { CompileFolder } from "./CompileFolder";
import { FreewallFilenamePrefix } from "@rezonence/sdk";

export const prefixMap: Record<FreewallFilenamePrefix, CompileFolder> = {
  Ad: CompileFolder.FullFlex,
  Pb: CompileFolder.Pub,
  Tag: CompileFolder.Tags
};
